import React, { useState, useEffect } from 'react';
import { ClipboardList, CheckCircle, XCircle, Clock, Loader2, Filter } from 'lucide-react';
import { API } from '../../config/apiBase';


export default function EmpresaSolicitaçõesPage() {
    const [ajustes, setAjustes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState('all');

    useEffect(() => {
        const token = localStorage.getItem('token') || sessionStorage.getItem('token');
        if (!token) return;
        fetch(`${API}/ponto/ajustes`, { headers: { 'Authorization': `Bearer ${token}` } })
            .then(r => r.json()).then(data => { setAjustes(Array.isArray(data) ? data : []); setLoading(false); })
            .catch(() => setLoading(false));
    }, []);

    const handleAction = async (id, status) => {
        const token = localStorage.getItem('token') || sessionStorage.getItem('token');
        try {
            const r = await fetch(`${API}/ponto/ajustes/${id}`, {
                method: 'PUT', headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: JSON.stringify({ status })
            });
            if (r.ok) {
                setAjustes(prev => prev.map(a => a.ajuste_id === id ? { ...a, status } : a));
            }
        } catch {}
    };

    const filtered = filter === 'all' ? ajustes : ajustes.filter(a => a.status === filter);
    const counts = { pendente: ajustes.filter(a => a.status === 'pendente').length, aprovado: ajustes.filter(a => a.status === 'aprovado').length, recusado: ajustes.filter(a => a.status === 'recusado').length };

    if (loading) return <div className="flex justify-center py-20"><Loader2 className="animate-spin" size={24} style={{ color: 'var(--sv-gold-primary)' }} /></div>;

    return (
        <div className="space-y-5" data-testid="empresa-solicitações">
            {/* Summary */}
            <div className="grid grid-cols-3 gap-3">
                {[
                    { label: 'Pendentes', value: counts.pendente, color: '#F59E0B' },
                    { label: 'Aprovadas', value: counts.aprovado, color: '#10B981' },
                    { label: 'Recusadas', value: counts.recusado, color: '#EF4444' },
                ].map((c) => (
                    <div key={c.label} className="rounded-xl p-3.5" style={{ background: 'var(--surface)', border: '1px solid var(--border)' }}>
                        <p className="text-xl font-bold" style={{ color: c.color }}>{c.value}</p>
                        <p className="text-[10px]" style={{ color: 'var(--muted)' }}>{c.label}</p>
                    </div>
                ))}
            </div>

            {/* Filter */}
            <div className="flex gap-2 overflow-x-auto" style={{ scrollbarWidth: 'none' }}>
                {[
                    { key: 'all', label: 'Todas' },
                    { key: 'pendente', label: 'Pendentes' },
                    { key: 'aprovado', label: 'Aprovadas' },
                    { key: 'recusado', label: 'Recusadas' },
                ].map((f) => (
                    <button key={f.key} onClick={() => setFilter(f.key)}
                        className="px-3 py-1.5 rounded-lg text-xs font-medium whitespace-nowrap transition-all"
                        style={{ background: filter === f.key ? 'rgba(var(--sv-accent-rgb), 0.15)' : 'var(--surface)', border: '1px solid var(--border)', color: filter === f.key ? 'var(--sv-accent)' : 'var(--muted)' }}>
                        {f.label}
                    </button>
                ))}
            </div>

            {/* List */}
            {filtered.length === 0 ? (
                <div className="text-center py-12 rounded-xl" style={{ background: 'var(--surface)', border: '1px solid var(--border)' }}>
                    <ClipboardList size={36} className="mx-auto mb-3" style={{ color: 'var(--muted)' }} />
                    <p className="text-sm" style={{ color: 'var(--text)' }}>Nenhuma solicitação {filter !== 'all' ? filter : ''}</p>
                    <p className="text-xs mt-1" style={{ color: 'var(--muted)' }}>Solicitações de ajuste dos colaboradores aparecerao aqui</p>
                </div>
            ) : (
                <div className="space-y-2">
                    {filtered.map((a) => {
                        const statusConfig = { pendente: { color: '#F59E0B', icon: Clock, bg: 'rgba(245,158,11,0.08)' }, aprovado: { color: '#10B981', icon: CheckCircle, bg: 'rgba(16,185,129,0.08)' }, recusado: { color: '#EF4444', icon: XCircle, bg: 'rgba(239,68,68,0.08)' } };
                        const sc = statusConfig[a.status] || statusConfig.pendente;
                        const StatusIcon = sc.icon;
                        return (
                            <div key={a.ajuste_id} className="rounded-xl p-4" style={{ background: 'var(--surface)', border: '1px solid var(--border)' }} data-testid={`ajuste-${a.ajuste_id}`}>
                                <div className="flex items-start justify-between mb-2">
                                    <div>
                                        <p className="text-sm font-medium" style={{ color: 'var(--text)' }}>{a.motivo || 'Ajuste de ponto'}</p>
                                        <p className="text-xs" style={{ color: 'var(--muted)' }}>
                                            {a.requested_by_name || a.user_id} - {a.created_at ? new Date(a.created_at).toLocaleDateString('pt-BR') : ''}
                                        </p>
                                    </div>
                                    <span className="flex items-center gap-1 text-[10px] px-2 py-0.5 rounded-full" style={{ background: sc.bg, color: sc.color }}>
                                        <StatusIcon size={10} /> {a.status}
                                    </span>
                                </div>
                                {a.status === 'pendente' && (
                                    <div className="flex gap-2 mt-3">
                                        <button onClick={() => handleAction(a.ajuste_id, 'aprovado')} className="flex items-center gap-1 px-3 py-1.5 rounded-lg text-xs font-medium transition-all"
                                            style={{ background: 'rgba(16,185,129,0.1)', color: '#10B981' }}>
                                            <CheckCircle size={12} /> Aprovar
                                        </button>
                                        <button onClick={() => handleAction(a.ajuste_id, 'recusado')} className="flex items-center gap-1 px-3 py-1.5 rounded-lg text-xs font-medium transition-all"
                                            style={{ background: 'rgba(239,68,68,0.1)', color: '#EF4444' }}>
                                            <XCircle size={12} /> Recusar
                                        </button>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
